import React from 'react';
import { Box } from '@mui/material';
import RenterFinancialCenter from '../components/financial/RenterFinancialCenter';

/**
 * Page autonome pour la vue financière locataire
 * Accès direct sans passer par FinancialHubPage
 */
const RenterFinancialPage = () => {
  return (
    <Box sx={{ 
      minHeight: 'calc(100vh - 230px)',
      position: 'relative',
      paddingBottom: '20px',
      display: 'flex', 
      flexDirection: 'column'
    }}>
      <Box sx={{ flexGrow: 1 }}>
        <RenterFinancialCenter key="renter-financial-center" />
      </Box>
    </Box>
  );
};

export default RenterFinancialPage;
